import { IApiEntitySmpAgTag } from "@smp/api";
import { UiAvatar, UiBox, UiChip } from "@smp/ui";

import { useSmpAgTranslation } from "@/hooks/use_smp_ag_translation";
import { useQueryPolotnoTagsAll } from "@/queries/polotno/use_query_polotno_tags_all";

import { useStyles } from "./selected_tag_chip.css";

export const SelectedTagChip = ({
  slug,
  onClick,
}: {
  slug: string;
  onClick: (tag: IApiEntitySmpAgTag) => void;
}) => {
  const getTranslation = useSmpAgTranslation();

  const {
    data: { normalized: normalizedTags },
  } = useQueryPolotnoTagsAll();

  const tag = normalizedTags?.get(slug);

  const classes = useStyles({
    color: tag?.parent === "color" ? tag.slug.split("_").at(-1) || "" : "",
  });

  if (!tag) {
    return null;
  }

  return (
    <UiChip
      className={classes.chip}
      label={getTranslation(tag?.translations)}
      avatar={
        tag.parent === "color" ? (
          <UiAvatar>
            <UiBox className={classes.color_circle} />
          </UiAvatar>
        ) : undefined
      }
      size="small"
      onDelete={() => onClick(tag)}
    />
  );
};
